<template>
  <div
    class="mt-3 d-md-flex">
    <div
      class="el-input pr-md-2 mb-2 mb-md-0"
      style="flex: 1;">
      <label for="phone">Phone Number</label>
      <tel-input
        :class="{error: !numericallyValid}"
        v-model="phoneNumber"
        @validate="validStateChange"
      />
    </div>
    <button
      class="btn btn-verify align-self-end"
      :class="{'btn-verify--verified': loadingState === 'valid'}"
      @click="validatePhoneNumber"
      :disabled="!numericallyValid || loadingState === 'saved'">
      <loading-icon
        v-if="loadingState === 'loading'"
        :loading="true"
        style="width: auto !important;position: absolute;margin-left:15px;"
        loading-class="text-left"
      />
      <span v-if="!loadingState">
        Verify number
      </span>
      <span v-else-if="loadingState === 'loading'">
        &nbsp;&nbsp;&nbsp;Verifying...
      </span>
      <span v-else-if="loadingState === 'valid'">
        <icon icon="tick-small" />
        Number verified
      </span>
      <span v-else-if="loadingState === 'saved'">
        Number saved
      </span>
    </button>
  </div>
</template>

<script>
import { VueTelInput as TelInput } from 'vue-tel-input'

export default {

  components: {
    TelInput,
  },

  props: {
    user: {
      required: true,
      type: Object,
    },
    axios: {
      required: true,
      type: Function,
    },
  },

  data () {
    return {
      loadingState: null,
      phoneNumber: null,
      numericallyValid: false,
    }
  },

  watch: {
    loadingState () {
      if (this.loadingState === 'valid') {
        setTimeout(() => {
          this.loadingState = null
        }, 5000)
      }
    },

    phoneNumber () {
      if (this.user.whatsapp && this.phoneNumber) {
        this.loadingState = this.phoneNumber.replace(/[^[0-9]+/g, '') === this.user.whatsapp.replace(/[^0-9]+/g, '') ? 'saved' : null
      }
    },
  },

  created () {
    this.phoneNumber = this.user.phone
    if (this.user.whatsapp) {
      this.phoneNumber = this.user.whatsapp
      this.loadingState = 'saved'
    }
  },

  methods: {
    async validatePhoneNumber () {
      this.loadingState = 'loading'
      const response = await this.axios.get(`phone-numbers/verify/${this.phoneNumber}`)
      if (response.data.data.valid) {
        this.loadingState = 'valid'
        this.subscribeToWhatsapp()
      }
    },

    validStateChange ({isValid}) {
      this.numericallyValid = isValid
    },

    async subscribeToWhatsapp () {
      this.user.whatsapp = this.phoneNumber
      this.loadingState = 'loading'

      try {
        await this.axios.put(`users/${this.user.id}/whatsapp`, {
          whatsapp: this.phoneNumber,
        })
        this.loadingState = 'saved'
        this.$notify({
          type: 'success',
          text: `Updated your WhatsApp phone number`,
        })
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>

<style lang="scss">
  .btn-verify {
    width: 180px;
    @media(max-width: 768px) {
      width: 100%;
    }
    height: 40px;
    background-color: #0080a8 !important;
    color: #fff !important;
    &:disabled {
      background-color: #c0c0c0 !important;
      &:hover {
        background-color: #c0c0c0 !important;
      }
    }

    &:hover {
      color: #fff !important;
      background-color: lighten(#0080a8, 5%) !important;
    }

    &--verified {
      background-color: #3aa93d !important;
    }
  }
</style>
